// extracted by mini-css-extract-plugin
module.exports = {"md":"HistoryList_md_3peiu","ios":"HistoryList_ios_2Cvrr","list":"HistoryList_list_15dyQ","empty":"HistoryList_empty_2YqYa","blockTitle":"HistoryList_blockTitle_2FkG6"};